/**
 * Created by Mattias on 2015-03-25.
 */

define('boxes/postal-mobile-verification-box',['jquery', 'boxes/box', 'boxes/events/loginEvent', 'boxes/helpers/loginHelper', 'all/comeon'], function ($, box, loginEvent, loginHelper, comeon) {
    'use strict';

    var backToLoginCallback = function () {
    };

    function init(postalAndMobileVerificationBox) {

        // The server-side-empty open dialog flow "forgotpw2" was used to open forgotPW2.jsp
        // No data is really needed, but countryCat of player was used to initialize country code

        postalAndMobileVerificationBox.model.shouldVerify = false;

        postalAndMobileVerificationBox.$controller.on(loginEvent.VERIFY_POSTAL_AND_MOBILE, function (event, mobileCountryCode) {
            event.preventDefault();
            postalAndMobileVerificationBox.model.shouldVerify = true;
            // TODO: Add + to country code or not?
            postalAndMobileVerificationBox.$box.find('input[name=PARAM_MOBILE_PHONE_COUNTRY_CODE]').val('+' + mobileCountryCode);
        });

        postalAndMobileVerificationBox.$controller.on(loginEvent.SET_BACK_TO_LOGIN_CALLBACK, function (event, backToLoginCallbackRef) {
            event.preventDefault();
            backToLoginCallback = backToLoginCallbackRef;
        });

        $('.sendPostalAndMobileVerification').off('click').on('click', function (event) {
            event.preventDefault();
            sendPostalAndMobileVerification(postalAndMobileVerificationBox);
        });

        var $form = postalAndMobileVerificationBox.$box.find('form');
        setupValidationConfiguration($form);

        var $elements = postalAndMobileVerificationBox.$box.find(':input');
        loginHelper.setupFocusPopover($elements);
    }

    function setupValidationConfiguration($form) {
        var validationConfiguration = {
            errorClass: loginHelper.ERROR_CLASS,
            validClass: loginHelper.VALID_CLASS,
            rules: {
                PARAM_POST_CODE: {
                    required: true,
                    minlength: 2,
                    maxlength: 30
                },
                PARAM_MOBILE_PHONE: {
                    required: true,
                    minlength: 2,
                    number: true
                }
            },
            highlight: loginHelper.highlight,
            unhighlight: loginHelper.unHighlight,
            errorPlacement: loginHelper.errorPlacement
        };
        $form.validate(validationConfiguration);
    }

    function sendPostalAndMobileVerification(postalAndMobileVerificationBox) {
        // Was submitting form with name ForgotPassword from forgotPW2.jsp with action ForgotPassword2
        // having elements PARAM_POST_CODE, PARAM_MOBILE_PHONE_COUNTRY_CODE, PARAM_MOBILE_PHONE
        var postCode = postalAndMobileVerificationBox.$box.find('input[name=PARAM_POST_CODE]').filter(':visible').val();
        var mobilePhoneCountryCode = postalAndMobileVerificationBox.$box.find('input[name=PARAM_MOBILE_PHONE_COUNTRY_CODE]').filter(':visible').val();
        var mobilePhone = postalAndMobileVerificationBox.$box.find('input[name=PARAM_MOBILE_PHONE]').filter(':visible').val();

        var completeMobilePhoneNumber = mobilePhoneCountryCode + mobilePhone;

        var flow = 'ForgotPassword2';
        var url = '/pp?flow=' + flow;
        $.post(url, {
            PARAM_POST_CODE: postCode,
            PARAM_MOBILE_PHONE: completeMobilePhoneNumber
        }, function (data) {
            sendPostalAndMobileVerificationCallback(postalAndMobileVerificationBox, data);
        });
    }

    function sendPostalAndMobileVerificationCallback(postalAndMobileVerificationBox, response) {
        if (response.RESULT !== 'OK') {
            loginHelper.handleErrorResponse(response, postalAndMobileVerificationBox);
        } else if (response.CODE === 'TEMP_PASSWORD_SENT_SMS') {
            // The close and confirm on this one will execute backToLoginCallback()
            loginHelper.showOneButtonPopup(postalAndMobileVerificationBox, '', response.TEXT, response.BUTTON_TEXT, backToLoginCallback);
        }
    }

    var view = {
            render: function () {}
        },
        model = {
            shouldVerify: undefined,
            init: function (postalAndMobileVerificationBox) {
                init(postalAndMobileVerificationBox);
            },
            beforeRender: function (postalAndMobileVerificationBox) {
                var shouldVerifyPromise = comeon.promise.create();
                if (postalAndMobileVerificationBox.model.shouldVerify) {
                    shouldVerifyPromise.resolve();
                } else {
                    shouldVerifyPromise.reject();
                }
                return [shouldVerifyPromise.promise()];
            },
            afterRender: function () {}
        };

    return {
        create: function ($box, $controller) {
            return box.create($box, $controller, view, model);
        }
    };
});
